import { memo, Fragment } from 'react';
import { useCalendar } from '../../Context.js';
import Day from './Day.js';
import { deriveDays } from '../../utils/index.js';
import { jsx } from 'react/jsx-runtime';

var Week = /*#__PURE__*/memo(function (props) {
  var date = props.date;
  var _useCalendar = useCalendar(),
    weekStartsOn = _useCalendar.weekStartsOn;
  return /*#__PURE__*/jsx(Fragment, {
    children: deriveDays({
      date: date,
      weekStartsOn: weekStartsOn
    }).map(function (day) {
      return /*#__PURE__*/jsx(Day, {
        date: day
      }, day.toString());
    })
  });
});
Week.displayName = 'Week';

export { Week as default };
